import { useReducedMotion } from "framer-motion";

// Dezente animierte Blueprint-Linien (SVG stroke-dash) + Mesh-Glow.
export default function BlueprintBackground() {
  const reduce = useReducedMotion();
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 blueprint-grid opacity-[0.5]" />
      <div
        className="absolute -top-40 right-0 h-[600px] w-[600px] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgba(61,220,151,0.18), transparent 70%)",
        }}
      />
      <svg
        className="absolute inset-0 h-full w-full opacity-30"
        preserveAspectRatio="none"
        viewBox="0 0 1200 600"
      >
        {[120, 260, 400, 540].map((y, i) => (
          <line
            key={y}
            x1="0"
            y1={y}
            x2="1200"
            y2={y - 60}
            stroke="#3DDC97"
            strokeWidth="1"
            strokeDasharray="6 10"
            style={
              reduce
                ? {}
                : {
                    strokeDashoffset: 400,
                    animation: `dash ${6 + i}s linear infinite`,
                  }
            }
          />
        ))}
      </svg>
    </div>
  );
}
